import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDatepicker } from '@angular/material/datepicker';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { LeavepageComponent } from 'src/app/shared/leavepage/leavepage.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';

interface PreviewDoc {
  url: string;
  previewUrl: any; // SafeResourceUrl from DomSanitizer
  mimeType: string;
  name: string;
  content_type?: string;
}

@Component({
    selector: 'app-add-calendar-dialog',
    templateUrl: './add-calendar-dialog.component.html',
    styleUrls: ['./add-calendar-dialog.component.css'],
    standalone: false
})
export class AddCalendarDialogComponent implements OnInit {
  @ViewChild('startPicker') startPicker!: MatDatepicker<Date>;
  
  categories = ['Personal', 'Health', 'Legal', 'Finance'];
  colors = ['USA', 'India', 'Germany', 'France'];
  // @BlockUI()
  // blockUI!: NgBlockUI; 
  submitted = false
  status: any;
  items: any;
  eventForm: any;
  contactForm!: FormGroup;
  searchText: string = '';

  notificationItems = [
    { method: 'notification', time: 10, unit: 'minutes', errorMsg: '' }
  ];
  hrs: any[] = [];
  tohrs: any[] = [];

  guests: any[] = [];
  filteredGuests: any[] = [];
  selectedGuests: any[] = [];
  searchTerm: string = '';
  showDropdown: boolean = false;
  entityMembers: any[] = [];
  selectedEntityMembers: any[] = [];
  selectedEntityId: string = '';
  showEntityMemberDropdown: boolean = false;
  isRecurringEvent: any;
  viewMode = true;
  editMode = false;
  selectedValue: string = 'Yes';
  internalInvitees:any[] = [];
  externalInvitees:any[] = [];
  timezones: any[] = [];
  selectedTimezone: string = '';
  today = new Date();
  minDate = new Date(this.today);   // copy of today
  maxDate = new Date(this.today);   // copy of today
  change:any;
  selectedTab: 'Event' | 'Reminder' = 'Event';
  //selectedTab: string = 'Event';

  // Add new properties for file preview
  previewDocument: PreviewDoc | null = null;
  isPreviewOpen = false;
  isPreviewLoading = false;
  allowedFileTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/rtf','text/csv','text/rtf','rtf'];
  docapi = environment.doc2pdf;
  allDayFlag = false;
  isChecked = true;
  patchData:any;
  matchedTz:any[]=[];

  constructor(private fb: FormBuilder, private auth: AuthService, private sanitizer: DomSanitizer,
    private dialog: MatDialog, private toast: ToastrService,private router: Router,
    private dialogRef: MatDialogRef<AddCalendarDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
   //console.log('dialog data', this.data)

    // Default selected tab based on event_type
    if (this.data?.event?.event_type === "reminder") {
      this.selectedTab = 'Reminder';
    } else {
      this.selectedTab = 'Event';
    }

    this.viewMode = !!this.data; // true if data is provided, false for create

    // setTimeout(() => {
    //   const input: HTMLInputElement | null = document.querySelector('.input-title');
    //   input?.focus();
    // }, 0);

  

    // Set focus on the input title
    setTimeout(() => {
      const textareas = document.querySelectorAll('.input-title');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });

    this.hrs = this.generateTimeSlots('00:00', '23:45', 15);
   // const nextDaySlots = this.generateTimeSlots('00:00', '23:30', 15);
    const nextDaySlots = this.generateTimeSlots('00:00', '23:45', 15);
    this.tohrs = [...this.hrs, ...nextDaySlots];
    

    // Find nearest slot and set default times
    const now = new Date();
    const nearestSlot = this.getNearestSlot(now);
    const toSlot = this.getNextSlot(nearestSlot, 4); // 1 hour = 4 steps of 15 mins

    this.eventForm = this.fb.group({
      title: ['', Validators.required],
      startDate: [new Date(), Validators.required],
      fromTime: [nearestSlot, Validators.required],
      toTime: [toSlot, Validators.required],
      allDay: [false],
      timezone: ['', Validators.required],
      repeat: ['NONE'], //NONE
      notification: ['10'],
      description: [''],
      invitees: [''],
      external: [''],
      meetingLink: [''],
      dialin: [''],
      location: [''],
      color: ['#FFA500']
    });

    // console.log('data', this.data);
    // console.log('eventForm', this.eventForm.value);

    if (!this.data) {
      this.viewMode = false; // If no `data` is provided, creating new event
    } else {
      this.viewMode = true; // If `data` is provided, view mode
    }

    if (this.viewMode) {
      this.eventForm.get('allDay')?.disable();
    } //else {
    //   this.eventForm.get('allDay')?.enable();
    // } // to disable the allday in viewmode

    if (this.data?.event) {
      this.patchEventData(this.data.event); // PATCH method for update

      if (this.data?.event.allday) {
        this.allDayEditMode({ target: { checked: true } });
        this.allDayFlag = true;
        localStorage.setItem('allday', this.allDayFlag.toString())
      } else {
        this.allDayFlag = false;
        localStorage.setItem('allday', this.allDayFlag.toString())
      }
      this.getTimezones();
    }

    if (this.data?.event?.owner_name && typeof this.data.event.owner_name === 'string') {
      const name = this.data.event.owner_name;
      this.data.event.owner_name = {
        name,
        initial: this.getInitial(name),
        color: this.getRandomColor(), // or fetch consistent color logic
      };
    }
    // Subscribe to fromTime changes
    this.eventForm.get('fromTime')?.valueChanges.subscribe((newFromTime: string) => {
      const nextSlot = this.getNextSlot(newFromTime, 4); // 1 hour later (4 steps of 15 mins)
      this.eventForm.patchValue({ toTime: nextSlot });
    });

    console.log('data',this.data)
    // this.getRelationships();
    this.getLists();
    this.getTimezones();

    this.eventForm.get('fromTime')?.valueChanges.subscribe((fromTime: string) => {
      if (fromTime) {
        const defaultToTime = this.getDefaultToTime(fromTime);
        this.eventForm.get('toTime')?.setValue(defaultToTime);
      }
    }); // 30mts meetup adds


    this.eventForm.get('allDay')?.valueChanges.subscribe((isAllDay: boolean) => {
      if (!isAllDay) {
        this.setDefaultTimes();
      }
    });
  }

  allDay(event: any) {
    // console.log(event.target.checked);
    if (event.target.checked) {
      this.allDayFlag = true;
      localStorage.setItem('allday', this.allDayFlag.toString())
      
      // Remove all notifications with unit = 'minutes'
      //this.removeNotification(event)
      this.notificationItems = this.notificationItems.filter(
        item => (item.unit !== 'minutes' && item.unit !== 'hours')
      );
      //console.log('Filtered notificationItems:', this.notificationItems);
    } else {
      this.allDayFlag = false;
      localStorage.setItem('allday', this.allDayFlag.toString())
    }
  }
    
  allDayEditMode(event: any) {
    //console.log(event.target.checked);
    if (event.target.checked) {
      this.allDayFlag = true;
      localStorage.setItem('allday', this.allDayFlag.toString())
    } else {
      this.allDayFlag = false;
      localStorage.setItem('allday', this.allDayFlag.toString())
    }
  }

  get descriptionValue(): string {
    const ctrl = this.eventForm?.get('description');
    if (!ctrl) return '';
    const v = ctrl.value;
    return (v ?? '').toString().trim();
  }
  get locationValue(): string {
    const ctrl = this.eventForm?.get('location');
    if (!ctrl) return '';
    const v = ctrl.value;
    return (v ?? '').toString().trim();
  }
  get dialinValue(): string {
    const ctrl = this.eventForm?.get('dialin');
    if (!ctrl) return '';
    const v = ctrl.value;
    return (v ?? '').toString().trim();
  }
  get meetingValue(): string {
    const ctrl = this.eventForm?.get('meetingLink');
    if (!ctrl) return '';
    const v = ctrl.value;
    return (v ?? '').toString().trim();
  }

  viewDocument(document: any): void {
   // console.log('Viewing document:', document);

    this.previewDocument = null;
    this.isPreviewOpen = true;
    this.isPreviewLoading = true;

    // Allowed file types to PDF
    const needsConversion = this.allowedFileTypes.includes(document.content_type);
    setTimeout(() => {
      if (needsConversion) {
        // Convert docs to PDF first
        this.auth.sendPostDecryptRequest(this.docapi, { url: document.url }).subscribe({
          next: (res: any) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            this.previewDocument = {
              ...document,
              previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl),
              mimeType: 'application/pdf'
            };
            this.isPreviewLoading = false;
          },
          error: (err) => {
            console.error('Error converting document:', err);
            this.toast.error('Failed to convert file.');
            this.isPreviewLoading = false;
          }
        });
      } else {
        // No conversion needed — show directly
        this.previewDocument = {
          ...document,
          previewUrl: this.sanitizer.bypassSecurityTrustResourceUrl(document.url),
          mimeType: document.content_type
        };
        this.isPreviewLoading = false;
      }
    }, 0);
  }

  // Preview document
  openPreview(document: PreviewDoc): void {
    this.previewDocument = document;
    this.isPreviewOpen = true;
  }

  closePreview(): void {
    this.previewDocument = null;
    this.isPreviewOpen = false;
  }

  // Switch tabs
  switchTab(tab: 'Event' | 'Reminder') {
    this.selectedTab = tab;
    // Set focus on the input title
    setTimeout(() => {
      const textareas = document.querySelectorAll('.input-title');
      const lastTextarea = textareas[textareas.length - 1] as HTMLTextAreaElement;
      if (lastTextarea) {
        lastTextarea.focus();
      }
    });
    this.notificationItems = [];
  }

//   setDefaultEndTime(): void {
//   const fromTime = this.eventForm.get('fromTime')?.value;

//   if (fromTime) {
//     // Example: add 1 hour
//     const [hours, minutes] = fromTime.split(':').map((n: string) => +n);
//     const date = new Date();
//     date.setHours(hours, minutes);

//     // Add 1 hour (default duration)
//     date.setHours(date.getHours() + 1);

//     const endHours = date.getHours().toString().padStart(2, '0');
//     const endMinutes = date.getMinutes().toString().padStart(2, '0');

//     this.eventForm.get('toTime')?.setValue(`${endHours}:${endMinutes}`);
//   } else {
//     // If fromTime not selected, set a generic default
//     this.eventForm.get('toTime')?.setValue('10:00');
//   }
// }

  setDefaultTimes(): void {
    // Round current time to the nearest option in hrs array:
    const now = new Date();

    // if your hrs are like "00:00", "00:30", "01:00"…
    const hh = now.getHours();
    const mm = now.getMinutes() < 30 ? '00' : '30';  // round to nearest half hour
    const fromTime = `${hh.toString().padStart(2, '0')}:${mm}`;

    // add 1 hour for end time
    const end = new Date();
    end.setHours(hh + 1);
    const endHH = end.getHours().toString().padStart(2, '0');
    const endMM = mm;
    const toTime = `${endHH}:${endMM}`;

    this.eventForm.get('fromTime')?.setValue(fromTime);
    this.eventForm.get('toTime')?.setValue(toTime);
  }

  get f() {
    return this.eventForm.controls;
  }

  getInitial(name: string): string {
    return name.trim().charAt(0).toUpperCase();
  }

  openStartPicker(): void {
  if (!this.viewMode) {
    this.startPicker.open();
  }
  }

  stripLeadingSpecialChars(controlName: string) {
    const ctrl = this.eventForm.get(controlName);
    if (ctrl) {
      const value = ctrl.value;
      ctrl.setValue(value.replace(/^[^a-zA-Z0-9]+/, ''), { emitEvent: false });
    }
  }

  stripLeadingSpecialCharsLink(controlName: string) {
    const ctrl = this.eventForm.get(controlName);
    if (ctrl) {
      const value = ctrl.value;
      ctrl.setValue(value.replace(/^[^a-zA-Z0-9:/-_=;?,]+/, ''), { emitEvent: false });
    }
  }

  onClickAttending(val: string) {
    this.selectedValue = val;
    // console.log('this.selectedValue', this.selectedValue)

    const id = this.data.event.id;
    // console.log('id', id)

    this.auth.updateRSVP(id, { rsvp_response: this.selectedValue }).subscribe(
      (res: any) => {
        this.toast.success(res.msg);
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          const errorMessage = error.error.msg || 'Unauthorized';
          this.toast.error(errorMessage);
          //console.log(error);
        }
      }
    );
  }

  toggleEditMode() {
    // console.log('tData',this.data)
    this.viewMode = false;
    this.editMode = true; // Switch to edit mode
    if(this.editMode || this.data?.event.allday === true){
      this.eventForm.get('allDay')?.enable();
    }

    setTimeout(() => {
      const input: HTMLInputElement | null = document.querySelector('.input-title');
      input?.focus();
    }, 0);
  }

  // getGuestName(guest: any) {
  //   //  console.log('Selected Guest:', guest);
  //   //  console.log('selectedGuests',this.selectedGuests)
  //   return guest.name || guest.entityName || guest.tmName;
  // }

  getGuestName(guest: any) {
    const guestName = guest.name || guest.entityName || guest.tmName;

    // stored parentGuestName if present
    if (guest.parentGuestName) {
      return `${guestName} - ${guest.parentGuestName}`;
    }

    const parentGuest = this.selectedGuests.find(
      (g: any) => g.id === guest.entityId || g.entityId === guest.entityId
    );

    return parentGuest
      ? `${guestName} - ${parentGuest.name}`
      : guestName;
  }

  getGuestInitial(guest: any): string {
    const name = guest.name || guest.entityName || guest.tmName || '';
    return name.trim().charAt(0).toUpperCase();
  }

  patchEventData(event: any) {
    //this.patchData = event;
    //console.log('Patching event data:', event);

    const startDate = new Date(event.from_ts);
    const endDate = new Date(event.to_ts);

    const fromTime = this.formatTimeTo24(startDate);
    const toTime = this.formatTimeTo24(endDate);

    // Parse notification items
    if (event.notifications && Array.isArray(event.notifications)) {
      this.notificationItems = event.notifications.map((notif: string) => {
        const [time, unit] = notif.split('-');
        return { method: 'notification', time: Number(time), unit };
      });
    } else {
      this.notificationItems = [];
    }

    // recurrence to UI value
    let repeatValue = 'NONE';
    if (event.isrecurring && event.recurrence_rule) {
      const freq = event.recurrence_rule.frequency;
      const interval = event.recurrence_rule.interval;
      if (freq === 'WEEKLY' && interval === 2) { repeatValue = 'BIWEEKLY';} 
      else if (freq === 'WEEKLY') { repeatValue = 'WEEKLY';} 
      else if (freq === 'DAILY') { repeatValue = 'DAILY';} 
      else if (freq === 'MONTHLY') { repeatValue = 'MONTHLY';} 
      else if (freq === 'YEARLY') { repeatValue = 'YEARLY';}
    }

    this.eventForm.patchValue({
      title: event.title,
      description: event.description || '',
      startDate,
      allDay: event.allday,
      fromTime,
      toTime,
      repeat: repeatValue,
      timezone: event.timezone_location,
      location: event.location,
      meetingLink: event.meeting_link,
      dialin: event.dialin
    });

    
    // Set external and internal invitees
    let external = event.invitees_external || [];
    let clientsList = external.map((person: any) => ({
      entName: person.entityName,
      tmName: person.tmName,
      rsvp: person.rsvp,
      entityId: person.entityId,
      tmId: person.tmId,
      type: 'entity'
    }));

    this.selectedGuests = [
      // Add internal invitees first
      ...(event.invitees_internal || []).map((guest: any) => ({
        name: guest.name,
        id: guest.id,
        rsvp: guest.rsvp,
        type: 'consumer',
        profile_url: guest.profile_url || '',
        color: this.getRandomColor(),
        initial: this.getGuestInitial(guest),
      }))
    ];

    this.selectedGuests.forEach((guest, index) => {
      //console.log(`Guest ${index + 1}:`, guest);
    });


    // Then group external invitees by entity name
    this.selectedEntityMembers = [];

    for (let i = 0; i < clientsList.length; i++) {
      let x = this.selectedEntityMembers.filter((val: any) => val.entName === clientsList[i].entName);
      let member = {
        name: clientsList[i].tmName,
        rsvp: clientsList[i].rsvp,
        tmId: clientsList[i].tmId,
        entityId: clientsList[i].entityId,
        entName: x.length > 0 ? '' : clientsList[i].entName,
        firstChar: (clientsList[i].tmName?.charAt(0))?.toUpperCase(),
        firstCharEntity: x.length > 0 ? '' : clientsList[i].entName?.charAt(0)?.toUpperCase(),
        profile_url: clientsList[i].profile_url || '',
        type: clientsList[i].type || '',
        color: this.getRandomColor(),
        id: clientsList[i].tmId,
        initial: (clientsList[i].tmName?.charAt(0))?.toUpperCase(),
      };
      this.selectedEntityMembers.push(member);

      //console.log('selectedEntityMembers guest', this.selectedEntityMembers)

      // Add both entity name (once) and members to selectedGuests flatly
      if (member.entName) {
        this.selectedGuests.push({
          name: member.entName,
          entityId: member.entityId,
          type: member.type,
          profile_url: '',
          color: this.getRandomColor(),
          initial: member.firstCharEntity,
        });
      }
    }

    //RSVP
    const currentUser = event.invitees_internal?.[0];
    if (currentUser?.rsvp) {
      this.selectedValue = this.capitalizeRsvp(currentUser.rsvp);
    } else {
      this.selectedValue = ''; // fallback
    }

    this.loadEntityMembers();

  }

  loadEntityMembers() {
    const memberEntityIds = new Set(this.selectedEntityMembers.map((m: any) => m.entityId));
    const existMemberIds = new Set(this.selectedEntityMembers.map((m: any) => m.tmId));
    // Create requests for each entityId
    const requests = Array.from(memberEntityIds).map(entityId =>{

      // 🔹 Find the entity object from selectedEntityMembers
      const entity = this.selectedEntityMembers.find((m: any) => m.entityId === entityId);
      const entityName = entity ? entity.entName : '';
      return this.auth.getEntityRelationships(entityId).pipe(
        map((res: any) =>
          (res.data.users || []).map((m: any) => ({
            ...m,
            entityId,
            initial: m.name ? m.name.charAt(0).toUpperCase() : '?',
            color: this.getRandomColor(),
            name: `${m.name} - ${entityName}`
          }))
        )
    )}
    );

    // Run all requests together
    forkJoin(requests).subscribe((allResults: any[][]) => {
      // Flatten all arrays into one
      const allMembers = allResults.flat();

      // Filter out existing members
      this.entityMembers = allMembers.filter(m => !existMemberIds.has(m.id));
      //console.log("Loaded Entity Members:", this.entityMembers);

    });
  }

  capitalizeRsvp(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  formatTimeTo24(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  // getTimezones() {
  //   this.auth.getTimezone().subscribe((res: any) => {
  //     this.timezones = res.data.timezones;

  //     const systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  //     console.log('System TimeZone:', systemTimeZone);  // e.g., "Asia/Kolkata"

  //     const matchedTz = this.timezones.find(tz => tz.value === systemTimeZone);
  //     this.eventForm.patchValue({ timezone: matchedTz?.value || this.timezones[0]?.value });
  //   });
  // }

  getTimezones() {
    this.auth.getTimezone().subscribe((res: any) => {
      this.timezones = res.data.timezones;

      let systemTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezoneAliases: { [key: string]: string } = {
        'Asia/Calcutta': 'Asia/Kolkata'
      };
      systemTimeZone = timezoneAliases[systemTimeZone] || systemTimeZone;

      // Only set default timezone if creating a new event
      if (!this.viewMode) {
        const matchedTz = this.timezones.find(tz => tz.value === systemTimeZone);
        this.eventForm.patchValue({
          timezone: matchedTz?.value || this.timezones[0]?.value
        });
      } else {
        // If in edit mode, re-patch the existing timezone after data is loaded
        const existingTz = this.data?.event?.timezone_location;
        if (existingTz) {
          const matchedTz = this.timezones.find(
            tz => tz.label === existingTz || tz.value === existingTz
          );
          if (matchedTz) {
            this.eventForm.patchValue({ timezone: matchedTz.value });
          }
        }
      }
    });
  }

  //   getTimezoneLabel(value: string): string {
  //   const tz = this.timezones.find(t => t.value === value);
  //   return tz ? tz.label : value;
  // }
  getTimezoneLabel(value: string): string {
    if (!value) return '-';
    const match = this.timezones.find(
      tz => tz.value === value || tz.label === value || tz.label.includes(value)
    );
    return match ? match.label : value;
  }


  getRelationships() {
    //timezone
    this.auth.getTimezone().subscribe((res: any) => {
     //console.log('get timezone', res)
    })
    //relationship
    this.auth.getRelationship().subscribe((res: any) => {
      // console.log('res2', res)
    })
  }

  getLists() {
    this.auth.getCleintRelationships().subscribe((res: any) => {
      this.guests = (res.data.relationships || []).map((g: any) => ({
        ...g,
        entityId: g.id,
        initial: g.name ? g.name.charAt(0).toUpperCase() : '?',
        color: this.getRandomColor()
      }));
      this.filterGuests();
    });
  }

  getEntityRel(entityId: any, entityName: string) {
    //console.log('Entity entityId', entityId);
    this.auth.getEntityRelationships(entityId).subscribe((res: any) => {
      let new_members = (res.data.users || []).map((m: any) => ({
        ...m,
        entityId:entityId,
        initial: m.name ? m.name.charAt(0).toUpperCase() : '?',
        color: this.getRandomColor(),
        name: `${m.name} - ${entityName}`
      }));
      this.entityMembers.push(...new_members);
    });
  }

  getRandomColor(): string {
    const colors = ['#0f6fff'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  filterGuests() {
    const term = this.searchTerm.toLowerCase();
    // console.log('f guests', this.guests);
    // console.log('f selectedEntityMembers', this.selectedEntityMembers);
    // console.log('f selectedGesuts',this.selectedGuests)
    // console.log('f selectedEntityId',this.selectedEntityId)
    this.filteredGuests = this.guests.filter(g =>
      g.name.toLowerCase().includes(term) &&
      !this.selectedGuests.some(sg => (sg.entityId || sg.id) === g.entityId)
    );
        
    
    //console.log('f filteredGuests', this.filteredGuests);
    localStorage.removeItem('removeGuestId');
  }

  get hasEntityGuest(): boolean {
    return this.selectedGuests?.some(g => g.type === 'entity');
  }

  // Add & Remove Participants
  addGuest(guest: any) {
    //console.log('Adding guest:', guest);
    if (!this.selectedGuests.some(g => g.id === guest.id)) {
      guest.entityId = guest.id
      this.selectedGuests.push(guest);
    }
    // console.log('selectedEntityMembers', this.selectedEntityMembers);
    // console.log('selectedGuests', guest);

    if (guest.type === 'entity') {
      this.selectedEntityId = guest.id;
      let id = localStorage.getItem('removeGuestId');
      this.getEntityRel(guest.id || id, guest.name);
      // Don't show member dropdown immediately
      this.showEntityMemberDropdown = false;
    } 
    else {
      if (this.selectedEntityMembers.length > 0 || this.selectedGuests.some(g => g.type === 'entity')) {
        // keep dropdown available if members still exist
        this.showEntityMemberDropdown = false;
      } else {
        this.showEntityMemberDropdown = false;
        this.entityMembers = [];
        this.selectedEntityMembers = [];
      }
    }

    this.searchTerm = '';
    this.showDropdown = false;
    this.filterGuests();
  }

  // removeGuest(guest: any) {
  //   console.log('Removing guest:', guest);
  //   const index = this.selectedGuests.findIndex(g => g.id === guest.id);
  //   if (index > -1) {
  //     this.selectedGuests.splice(index, 1);
  //   }
  //  // this.filterGuests(); // Update dropdown again
  // }

  // removeEntityMember(member: any) {
  //   console.log('Removing entity member:', member);
  //   const index = this.selectedEntityMembers.findIndex(m => m.id === member.id);
  //   if (index > -1) {
  //     this.selectedEntityMembers.splice(index, 1);
  //   }
  // }

  //  removeGuest(guest: any) {
  //   console.log('Removing guest:', guest);
  //   const index = this.selectedGuests.findIndex(g => g.name === guest.name);
  //   if (index > -1) {
  //     this.selectedGuests.splice(index, 1);
  //   }
  // }

  removeGuest(guest: any) {
    // console.log('Removing guest:', guest);
    localStorage.setItem('removeGuestId', guest?.entityId || guest?.id);

    // 1. Remove guest from selectedGuests
    const index = this.selectedGuests.findIndex(g => g.name === guest.name);
    if (index > -1) {
      this.selectedGuests.splice(index, 1);
    }
    if(guest.type === 'consumer'){
      this.filteredGuests = [guest, ...this.filteredGuests]; // Make consumer available again in dropdown
    }

    // 2. If guest is an entity, remove all its members from selectedEntityMembers
    if (guest.type === 'entity') {
      this.selectedEntityMembers = this.selectedEntityMembers.filter(member => member.entityId !== guest.entityId);
      this.entityMembers = this.entityMembers.filter(member => member.entityId !== guest.entityId);
      this.filteredGuests.push(guest); // Make entity available again in dropdown

      // Also remove members of that entity from selectedGuests
      this.selectedGuests = this.selectedGuests.filter(g => g.entityId !== guest.entityId || g.type !== 'member');
    }

    // 3. If guest is a member, remove from selectedEntityMembers
    if (guest.type === 'member') {
      this.selectedEntityMembers = this.selectedEntityMembers.filter(member => member.tmId !== guest.tmId);

      // Optional: if no more members from that entity, remove the entity itself
      const stillHasMembers = this.selectedEntityMembers.some(m => m.entityId === guest.entityId);
      if (!stillHasMembers) {
        this.selectedGuests = this.selectedGuests.filter(g => g.entityId !== guest.entityId || g.type !== 'entity');
      }
    }

    // console.log('..sel Guests:', this.selectedGuests);
    // console.log('..sel Entity Members:', this.selectedEntityMembers);
    // console.log('..Entity Members:', this.entityMembers);
  }

  removeEntityMember(member: any) {
    // console.log('Removing entity member:', member);
    // console.log('selected one',this.selectedEntityMembers)
    const index = this.selectedEntityMembers.findIndex(m => m.id === member.id);
    if (index > -1) {
      this.selectedEntityMembers.splice(index, 1);
      this.entityMembers.push(member); // Make member available again in dropdown
    }
  }

  // Entity Members
  filterEntityMembers() {
    const term = this.searchText.toLowerCase();
    this.entityMembers = this.entityMembers.filter(m =>
      m.name.toLowerCase().includes(term) &&
      !this.selectedEntityMembers.some(sm => sm.id === m.id)
    );
    //console.log('Filtered Entity Members:', this.entityMembers);
  }

//   filterEntityMembers() {
//   const term = this.searchText.toLowerCase();
//   this.entityMembers = this.entityMembers.filter(m =>
//     m.name.toLowerCase().includes(term) &&
//     !this.selectedEntityMembers.some(sm => sm.tmId === m.tmId)
//   );
// }

  onEntityMemberInput() {
    this.showEntityMemberDropdown = true;
    this.filterEntityMembers();
  }

  addEntityMember(member: any) {
    if (!this.selectedEntityMembers.some(m => m.id === member.id)) {
      this.selectedEntityMembers.push(member);
    }
    this.searchText = '';
    this.showEntityMemberDropdown = false; // ⬅ Close the dropdown after selection
    this.filterEntityMembers();
  }

  hideDropdownWithDelay() {
    setTimeout(() => {
      this.showDropdown = false;
    }, 200);
  }

  hideEntityDropdownWithDelay() {
    setTimeout(() => {
      this.showEntityMemberDropdown = false;
    }, 200); // Delay to allow click event on li to fire first
  }


  closeDropdown(event: MouseEvent, selector: string, flag: 'guest' | 'member') {
    const target = event.target as HTMLElement;  // If click is outside the dropdown container close it
    if (!target.closest(selector)) {
      if (flag === 'guest') this.showDropdown = false;
      if (flag === 'member') this.showEntityMemberDropdown = false;
    }
  }

  //Add Notifications & Times
  formatNotification(item: any): string {
    const time = item.time ?? 0;
    const unit = item.unit ?? 'minutes';
    return `${time} ${unit} before`;
  }

  displayDate(date: Date | null): string {
    return date ? new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(date) : '';
  }

  addNotification() {
    console.log('allDayFlag', this.allDayFlag);

    // decide default values based on flag
    const defaultUnit = this.allDayFlag ? 'days' : 'minutes';
    const defaultTime = this.allDayFlag ? 1 : 10;

    // always push a new notification
    this.notificationItems.push({
      method: 'notification',
      time: defaultTime,
      unit: defaultUnit,
      errorMsg: ''
    });
  }


//   addNotification() {
//     this.notificationItems.push({
//       method: 'notification',
//       time: 10,
//       unit: 'minutes',
//       errorMsg: ''
//     });
//  }

  ChangeNotificationValidation(value: any, type: any, index: number) {
  const item = this.notificationItems[index];
  item.errorMsg = '';  // Clear previous message

  const numVal = Number(value);

  switch (type) {
    case 'minutes':
      if (numVal < 1 || numVal > 60) {
        item.errorMsg = 'Must be between 1 to 60 minutes';
      }
      break;

    case 'hours':
      if (numVal < 1 || numVal > 24) {
        item.errorMsg = 'Must be between 1 to 24 hours';
      }
      break;

    case 'days':
      if (numVal < 1 || numVal > 31) {
        item.errorMsg = 'Must be between 1 to 31 days';
      }
      break;

    case 'weeks':
      if (numVal < 1 || numVal > 4) {
        item.errorMsg = 'Must be between 1 to 4 weeks';
      }
      break;
  }
}

  removeNotification(index: number) {
    this.notificationItems.splice(index, 1);
  }

  // Helper to generate time slots
  generateTimeSlots(start: string, end: string, stepMinutes: number): string[] {
    const times: string[] = [];
    let [hour, minute] = start.split(':').map(Number);
    const [endHour, endMinute] = end.split(':').map(Number);

    while (hour < endHour || (hour === endHour && minute <= endMinute)) {
      const hh = hour.toString().padStart(2, '0');
      const mm = minute.toString().padStart(2, '0');
      times.push(`${hh}:${mm}`);
      minute += stepMinutes;
      if (minute >= 60) {
        minute = 0;
        hour++;
      }
    }
    return times;
  }

  getNearestSlot(date: Date): string {
    const hour = date.getHours();
    const minutes = date.getMinutes();
    let roundedMinutes = 0;
    if (minutes === 0) {
      roundedMinutes = 0;
    } else if (minutes <= 30) {
      roundedMinutes = 30;
    } else {
      roundedMinutes = 0;
      return `${(hour + 1).toString().padStart(2, '0')}:00`;
    }

    return `${hour.toString().padStart(2, '0')}:${roundedMinutes.toString().padStart(2, '0')}`;
  }

  getNextSlot(currentSlot: string, stepCount: number): string {
    const index = this.tohrs.findIndex(t => t === currentSlot);
    if (index === -1) {
      // console.warn(`Slot ${currentSlot} not found in tohrs.`);
      return this.tohrs[0]; // fallback
    }
    let nextIndex = index + stepCount;
    if (nextIndex >= this.tohrs.length) {
      nextIndex = this.tohrs.length - 1;
    }
    return this.tohrs[nextIndex];
  }

  formatTime24to12(time: string): string {
    const [hours, minutes] = time.split(':').map(Number);
    const suffix = hours >= 12 ? 'PM' : 'AM';
    const hour12 = hours % 12 || 12;
    return `${hour12}:${minutes < 10 ? '0' + minutes : minutes} ${suffix}`;
  }

  private combineDateAndTime(date: Date, time: string): Date {
  const [hours, minutes] = time.split(':').map(Number);
  const dt = new Date(date);
  dt.setHours(hours, minutes, 0, 0);
  return dt;
}

  //tohrs code
  getFilteredToTimeSlots(): string[] {
    const fromTime = this.eventForm?.get('fromTime')?.value;
    if (!fromTime) {
      return this.tohrs;
    }
    const index = this.tohrs.findIndex(t => t === fromTime);
    if (index === -1) {
      return this.tohrs;
    }
    return this.tohrs.slice(index + 1);
  }

  getDefaultToTime(fromTime: string): string | null {
    const [hours, minutes] = fromTime.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes);

    // Add 30 minutes
    date.setMinutes(date.getMinutes() + 30);

    // Format back to HH:mm
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    return `${hh}:${mm}`;
  }

  onKey(event: any, index: number, field: string) {
    const value = event.target.value;
    //console.log(`Changed: ${field} to ${value} at index ${index}`);
  }

  onOptionsSelected(event: any, index: number) {
    const value = event.target.value;
    //console.log(`Changed type to ${value} at index ${index}`);
  }

  formatDateTime(dateOrDateString: Date | string, time?: string): string {
    let dt: Date;
    if (dateOrDateString instanceof Date && !time) {
      dt = dateOrDateString;
    } else {
      const date = new Date(dateOrDateString);
      const [hours, minutes] = (time || '00:00').split(':').map(Number);
      dt = new Date(date);
      dt.setHours(hours, minutes, 0, 0);
    }

    const yyyy = dt.getFullYear();
    const mm = this.pad(dt.getMonth() + 1);
    const dd = this.pad(dt.getDate());
    const hh = this.pad(dt.getHours());
    const mi = this.pad(dt.getMinutes());
    const ss = this.pad(dt.getSeconds());

    return `${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`;
  }

  // Open recurring edit dialog
  openRecurringEditDialog(): Promise<'this' | 'forward' | 'all' | null> {
    const dialogRef = this.dialog.open(RecurringEditDialogComponent, {
      width: '360px',
      height: '250px',
      disableClose: true, // Prevent outside close
      data: {
        options: ['this', 'forward', 'all'],
        data: this.data
      }
    });

    return dialogRef.afterClosed().toPromise();
  }

  get durationText() {
    const dur = this.getMeetingDuration();
    return dur ? `${dur.hours} Hours, ${dur.minutes} Minutes` : '';
  }

  getMeetingDuration() {
    const from = this.eventForm.get('fromTime')?.value;
    const to = this.eventForm.get('toTime')?.value;

    if (!from || !to) return null;

    // from & to are like '09:00' or '14:30'
    const [fromH, fromM] = from.split(':').map(Number);
    const [toH, toM] = to.split(':').map(Number);

    const fromDate = new Date();
    fromDate.setHours(fromH, fromM, 0, 0);

    const toDate = new Date();
    toDate.setHours(toH, toM, 0, 0);

    let diff = (toDate.getTime() - fromDate.getTime()) / (1000 * 60); // minutes
    if (diff < 0) diff += 24 * 60; // handle overnight meetings

    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;

    return { hours, minutes };
  }

    deleteDocument() {
      //console.log('del data',this.data)
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { title: 'Delete Event', message: `Are you sure you want to delete ${this.data?.event.title} event?`, sub: 'You will not be able to recover it once it is deleted.' }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        //console.log('rrr',result)
        if(result)
          this.deleteEvent()
      });
    }

  async deleteEvent() {
    localStorage.removeItem('repeat_interval')
    const isRecurring = this.data.event?.isrecurring;
    let payload: any = {
      recurrent_edit_choice: this.eventForm.value.recurrent_edit_choice || 'this'  // optional fallback
    };

    if (isRecurring) {
      localStorage.setItem('delevent', 'true');
      const choice = await this.openRecurringEditDialog(); // ⬅ await is critical here!
      if (!choice) return; // User cancelled

      payload.recurrent_edit_choice = choice || 'this';
    }

    this.auth.deleteCalendar(this.data.event?.id, (payload.recurrent_edit_choice || 'this')).subscribe(
      (res: any) => {
        this.toast.success(res.msg);
        this.dialogRef.close();
      },
      (error: HttpErrorResponse) => {
        this.toast.error(error.error.msg || 'Failed to delete event');
      }
    );
  }

  // onCancel() {
  //   this.dialogRef.close();
  //   this.eventForm.reset();
  // }

  async onCancel() {
    // console.log('Form dirty:', this.eventForm.dirty);
    // console.log('data:', this.data);
    // console.log('viewMode:', this.viewMode);
    // console.log('Form values:', this.eventForm.value);
    // console.log('allday1:', this.allDayFlag);
    // console.log('allday2:', this.isAllDay);
    // console.log('notifyItems:', this.notificationItems);
    const notification = this.notificationItems.map((item: any) => `${item.time}-${item.unit}`);
    // console.log('notify', notification);

    if (this.eventForm.dirty ||
      (this.selectedGuests.length > 0 && this.viewMode===false)  || 
      (notification[0] !== "10-minutes" && this.selectedTab === 'Event' && this.data.isLeave === true) || 
      (this.notificationItems.length > 1 && this.viewMode===false)) {
      const dialogRef = this.dialog.open(LeavepageComponent, {
        width: '350px',
        height: '180px',
        disableClose: true,
        hasBackdrop: true,
        panelClass: 'hello',
        data: { 
          //isLeave: true 
          isLeave: this.data?.event?.allday == true ? false : true
          }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log('res', result)
        if (result) {
          this.dialogRef.close();
          this.eventForm.reset();
        }
      });
      return;
    }

  // No changes, just close
  this.dialogRef.close();
  this.eventForm.reset();
  //this.refreshConnectionPage();
  localStorage.removeItem('repeat_interval')
  localStorage.removeItem('allday')
}


  hasError(controlName: any): boolean {
    return this.submitted && this.eventForm.get(controlName)?.invalid || false;
  }

  preventNegativeInput(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === 'Minus') {
      event.preventDefault();
    }
  }

  enforceNonNegative(index: number): void {
    const unit = this.notificationItems[index].unit;
    const value = this.notificationItems[index].time;
    if (value < 0 || isNaN(value)) {
      this.notificationItems[index].time = 0; // Or set your default if needed
    }

    //  let value = parseInt(String(this.notificationItems[index].time), 10); // automatically set val
    // if (isNaN(value) || value < 0) {
    //   switch (unit) {
    //     case 'minutes':
    //       this.notificationItems[index].time = 10;
    //       break;
    //     case 'hours':
    //     case 'days':
    //     case 'weeks':
    //       this.notificationItems[index].time = 1;
    //       break;
    //   }
    // }
  }


  pad(n: number): string {
   return n < 10 ? '0' + n : '' + n;
  }

  validateEntityMembers(): boolean {  
    // collect all member entityIds into a Set for fast lookup
    const memberEntityIds = new Set(this.selectedEntityMembers.map((m: any) => m.entityId));

    // collect missing entity guest names
    const missingEntityNames = this.selectedGuests
      .filter((guest: any) => guest.type === 'entity' && !memberEntityIds.has(guest.entityId))
      .map((guest: any) => guest.name);

    //console.log("Missing entity names:", missingEntityNames);

    if (missingEntityNames.length > 0) {
      const word = missingEntityNames.length > 1 ? "these firms" : "this firm";
      this.toast.error(`Please select members for ${word}: ${missingEntityNames.join(", ")}`);
      return false; //validation failed
    }
    return true; // all good
  }

  async onSubmit() {
    if (!this.validateEntityMembers()) return; // stop form submission if invalid
  
    this.submitted = true;
    const formValue = this.eventForm.value;
    console.log('formValue', formValue);

    // Find the selected timezone object from the full list
    const selectedTimezoneObj = this.timezones.find(
      (tz: any) => tz.value === formValue.timezone
    );

    // Fallback offset if not found
    const timezoneOffset = selectedTimezoneObj?.offset ?? 0;
    // const notification = this.notificationItems.map((item: any) => `${item.time}-${item.unit}`);
              
    // If no notifications exist, add a default "10-minutes"
     //console.log('notificationItems', this.notificationItems);

    if (!this.notificationItems) {
      this.notificationItems = [{
        method: 'notification',
        time: 10,
        unit: 'minutes',
        errorMsg: ''
      }];
    }

    // Ensure all notifications have default values if empty
    this.notificationItems = this.notificationItems.map((item: any) => {
      const unit = item.unit || item.type || 'minutes';
      let time = item.time;
      let method = item.method || 'notification';
      let errorMsg = item.errorMsg || '';

      // Handle empty or invalid time values
      if (!time || (typeof time === 'string' && time.trim() === "")) {
        if (unit === "minutes") time = 10;
        else if (unit === "hours") time = 1;
        else if (unit === "weeks") time = 1;
        else if (unit === "days") time = 1;
      }

      // Handle "-unit" cases
      if (typeof time === 'string') {
        if (time.trim() === "-minutes") time = 10;
        if (time.trim() === "-hours") time = 1;
        if (time.trim() === "-weeks") time = 1;
        if (time.trim() === "-days") time = 1;
      }

      return {
        method,
        time: Number(time),
        unit,
        errorMsg
      };
    });
    //console.log('notificationItems', this.notificationItems);

    // Convert to desired format
    const notification = this.notificationItems.map((item: any) => `${item.time}-${item.unit}`);
    //console.log('notify', notification);

    // Add all selected consumers to internal invitees
    this.selectedGuests.forEach((guest: any) => {
      if (guest.type === 'consumer') {
        this.internalInvitees.push(guest.id);
      } 
    });

    // Add all selected entity members to external invitees
    this.selectedEntityMembers.forEach((member: any) => {
      // console.log('memo',member)
          if (member.id) this.externalInvitees.push(`${member.entityId}_${member.id}`);
    });
    
    // console.log('selectedGuests',this.selectedGuests)
    // console.log('selEntmem',this.selectedEntityMembers)
        
    // this.selectedGuests.forEach((guest: any) => {
    //   if (guest.type === 'consumer') {
    //     this.internalInvitees.push(guest.id);
    //   } else if (guest.type === 'entity' && guest.members) {
    //     guest.members.forEach((member: any) => {
    //       this.externalInvitees.push(`${guest.id}_${member.id}`);
    //     });
    //   }
    // });

    // let from_ts = '';
    // let to_ts = '';
    // if (formValue.allDay) {
    //   const start = new Date(formValue.startDate);
    //   from_ts = `${start.getFullYear()}-${this.pad(start.getMonth() + 1)}-${this.pad(start.getDate())} 00:00:00`;
    //   to_ts = `${start.getFullYear()}-${this.pad(start.getMonth() + 1)}-${this.pad(start.getDate())} 23:59:59`;
    // } else {
    //   from_ts = this.formatDateTime(formValue.startDate, formValue.fromTime);
    //   to_ts = this.formatDateTime(formValue.startDate, formValue.toTime);
    // }

    let from_ts = '';
    let to_ts = '';

    if (formValue.allDay) {
      const start = new Date(formValue.startDate);
      from_ts = `${start.getFullYear()}-${this.pad(start.getMonth() + 1)}-${this.pad(start.getDate())} 00:00:00`;
      to_ts = `${start.getFullYear()}-${this.pad(start.getMonth() + 1)}-${this.pad(start.getDate())} 23:59:59`;
    } else {
      const startDate = new Date(formValue.startDate);

      const fromDateTime = this.combineDateAndTime(startDate, formValue.fromTime);
      let toDateTime = this.combineDateAndTime(startDate, formValue.toTime);

      // if toTime is before fromTime (crossing midnight), add +1 day
      if (toDateTime <= fromDateTime) {
        toDateTime.setDate(toDateTime.getDate() + 1);
      }

      from_ts = this.formatDateTime(fromDateTime);
      to_ts = this.formatDateTime(toDateTime);
    }

    const recurrenceRule = {
      frequency: formValue.repeat === 'BIWEEKLY' ? 'WEEKLY' : formValue.repeat,
      interval: formValue.repeat === 'BIWEEKLY' ? 2 : 1
    };

    // console.log('selectedGuests', this.selectedGuests);
    // console.log('selectedEntityMembers', this.selectedEntityMembers);
    // console.log('data',this.data)

    let isAllDay = this.isAllDay; //get all day
    // console.log('isallday',isAllDay)

    //console.log('selectedTab',this.selectedTab)
    let eventType
    if (this.selectedTab === 'Reminder') {
      eventType = "reminder";
    }
    else {
      eventType = "consumer";
    }

    const tzValue = this.eventForm.get('timezone')?.value; // e.g. "Asia/Kolkata"
    const tzLabel = this.getTimezoneLabel(tzValue); // e.g. "India Standard Time (Asia/Kolkata)"
    // console.log('Value to API:', tzValue);
    // console.log('Label for UI:', tzLabel);

    let payload: any = {
      title: formValue.title,
      date: formValue.startDate,
      // from_ts: this.formatDateTime(formValue.startDate, formValue.fromTime),
      // to_ts: this.formatDateTime(formValue.startDate, formValue.toTime),
      from_ts: from_ts,
      to_ts: to_ts,   
      timezone_location: tzLabel,
      timezone_offset: timezoneOffset,
      event_type: eventType,
      allday: isAllDay,
      color: "#FFA500",
      recurrence_rule: recurrenceRule,
      meeting_link: formValue.meetingLink,
      dialin: formValue.dialin,
      location: formValue.location,
      description: formValue.description,
      attachments: [],
      invitees_external: this.externalInvitees,
      invitees_internal: this.internalInvitees,
      notifications: notification
    };

    // console.log('selectedGuests', this.selectedGuests);
    // console.log('selectedEntityMembers', this.selectedEntityMembers);
    // console.log('payload', payload);
    // console.log('data',this.data)

    // 🔄 If updating an event
    if (this.data) {
      const isRecurring = this.data.event?.isrecurring; // 🔁 Handle recurring edit choice
      let p = payload.recurrence_rule?.frequency === "NONE";
      console.log('data',this.data)
      console.log('p', p)
      console.log('isRecurring', isRecurring)

      if (this.eventForm.pristine && isRecurring===false) {
        let id = this.data.event.id;
        // go straight to update without opening the recurring edit dialog
        this.auth.updateCalendar(id, payload).subscribe(
          (res: any) => {
            this.toast.success(res.msg);
            this.dialogRef.close();
            this.eventForm.reset();
          },
        );
        this.dialogRef.close();
        return;
      }

      if (isRecurring && !p) {
        const choice = await this.openRecurringEditDialog();
        if (!choice) return; // Cancelled
        payload.recurrent_edit_choice = choice; // Set based on dialog result
      }
      // const allday = this.data.event.allday
      // payload.allday = allday

      let id = this.data.event.id;
      const previousInternalIds = (this.selectedGuests).map((i: any) => i.id);
      const previousExternalIds = this.selectedEntityMembers
                  .filter((e: any) => e.entityId && e.tmId)   // only those with both entityId & tmId
                .map((e: any) => `${e.entityId}_${e.tmId}`);
      // const previousExternalIds = (this.selectedEntityMembers).map((e: any) => `${e.entityId}_${e.tmId}`);
      // payload.invitees_internal = Array.from(new Set([...previousInternalIds, ...this.internalInvitees]));
      // payload.invitees_external = Array.from(new Set([...previousExternalIds, ...this.externalInvitees]));

      payload.invitees_internal = Array.from(new Set([
        ...previousInternalIds,
        ...this.internalInvitees
      ])).filter(id => id != null);

      payload.invitees_external = Array.from(new Set([
        ...previousExternalIds,
        ...this.externalInvitees
      ])).filter(id => id != null);

      // console.log('data',this.data)
      // console.log("formValue",this.eventForm.value)
      // console.log('updata payload', payload);

      this.auth.updateCalendar(id, payload).subscribe(
        (res: any) => {
          this.toast.success(res.msg);
          this.dialogRef.close();
          this.eventForm.reset();
        },
        // (error: HttpErrorResponse) => {
        //   this.toast.error(error.error.msg || 'Failed to update event');
        // }
        (error: HttpErrorResponse) => {
          //console.error('Full error response:', error);

          if (error.status === 500) {
            this.toast.error('Server error occurred. Please try again.');
          }
          else if (Array.isArray(error.error?.errors) && error.error.errors.length) {
            // Loop through and show each field-specific error
            error.error.errors.forEach((err: any) => {
              this.toast.error(`${err.msg}`);
            });
          }
          else if (typeof error.error?.msg === 'string') {
            this.toast.error(error.error.msg);
          }
          else if (typeof error.error === 'string') {
            this.toast.error(error.error); // In case backend sends plain text
          }
          else {
            this.toast.error('An error occurred. Please try again.');
          }
        }

      );
    } else {
      this.auth.addCalendar(payload).subscribe({
        next: (res: any) => {
          this.toast.success(res.msg);
            this.dialogRef.close();
            this.eventForm.reset();
        },
        // error: (error: HttpErrorResponse) => {
        //   if (error.status === 500) {
        //     this.toast.error('Server error occurred. Please try again.');
        //   } else if (error.error?.errors?.length) {
        //     // Loop through and show each field-specific error
        //     error.error.errors.forEach((err: any) => {
        //       this.toast.error(`${err.field}: ${err.msg}`);
        //     });
        //   } else {
        //     this.toast.error(error.error?.msg || 'An error occurred. Please try again.');
        //   }
        // }
        error: (error: HttpErrorResponse) => {
          //console.error('Full error response:', error);

          if (error.status === 500) {
            this.toast.error('Server error occurred. Please try again.');
          }
          else if (Array.isArray(error.error?.errors) && error.error.errors.length) {
            // Loop through and show each field-specific error
            error.error.errors.forEach((err: any) => {
              this.toast.error(`${err.msg}`);
            });
          }
          else if (typeof error.error?.msg === 'string') {
            this.toast.error(error.error.msg);
          }
          else if (typeof error.error === 'string') {
            this.toast.error(error.error); // In case backend sends plain text
          }
          else {
            this.toast.error('An error occurred. Please try again.');
          }
        }


      });

    }
    //this.refreshConnectionPage();
    localStorage.removeItem('allday')
  }

  get isAllDay(): boolean {
  return this.eventForm.get('allDay')?.value;
  }

  refreshConnectionPage() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/calendar']);
    });
  }//refreshin comp.

  getRepeatLabel(value: string): string {
    const mapping: { [key: string]: string } = {
      NONE: 'None',
      DAILY: 'Daily',
      WEEKLY: 'Weekly',
      BIWEEKLY: 'Bi-Weekly',
      MONTHLY: 'Monthly',
      YEARLY: 'Yearly'
    };
    return mapping[value] || value || '';
  }

  getTimeLabel(value: string): string {
    const mapping: { [key: string]: string } = {
      minutes: 'Minutes',
      hours: 'Hours',
      days: 'Days',
      weeks: 'Weeks'
    };
    
    // Hide minutes/hours when allDayFlag is true
    if (this.allDayFlag && (value === 'minutes' || value === 'hours')) {
      return ''; // return empty so it won’t render
    }

    return mapping[value] || value || '';
  }
 

  // Called when time input changes
  onNotificationTimeChange(event: any, index: number) {
    let value = event.target.value;
    value = value.replace(/[^0-9]/g, ''); // Remove non-numeric
    this.notificationItems[index].time = value;

    this.validateNotification(index);
  }

  // Called when unit changes
  onNotificationUnitChange(event: any, index: number) {
    const unit = event.value;
    this.notificationItems[index].unit = unit;
    this.validateNotification(index);
  }

  // Validate notification value based on unit
  validateNotification(index: number) {
    const item = this.notificationItems[index];
    item.errorMsg = ''; // reset

    const value = Number(item.time);
    const type = item.unit;

    // if (!value) {
    //   item.errorMsg = 'This field is required';
    //   return;
    // }

    if (type === 'minutes' && (value < 1 || value > 60)) {
      item.errorMsg = 'Must be between 1 to 60 minutes';
    } else if (type === 'hours' && (value < 1 || value > 24)) {
      item.errorMsg = 'Must be between 1 to 24 hours';
    } else if (type === 'days' && (value < 1 || value > 31)) {
      item.errorMsg = 'Must be between 1 to 31 days';
    } else if (type === 'weeks' && (value < 1 || value > 4)) {
      item.errorMsg = 'Must be between 1 to 4 weeks';
    }
  }

  // filterGuests() {
  //   const term = this.searchTerm.toLowerCase();
  //   this.filteredGuests = this.guests.filter(g =>
  //     g.name.toLowerCase().includes(term) &&
  // !this.selectedGuests.some(sg => sg.id === g.id || sg.name === g.name)
  //   );
  // }

  // filterEntityMembers() {
  //   const term = this.searchText.toLowerCase();
  //   this.entityMembers = this.entityMembers.filter(m =>
  //     m.name.toLowerCase().includes(term) &&
  //     !this.selectedEntityMembers.some(sm => sm.tmId === m.tmId)
  //   );
  // }
  // addGuest(guest: any) {
  //   if (!this.selectedGuests.some(g => g.id === guest.id)) {
  //     this.selectedGuests.push({ ...guest, type: 'guest' });
  //   }

  //   if (guest.type === 'entity') {
  //     this.selectedEntityId = guest.id;
  //     this.getEntityRel(guest.id); // fetch members
  //     this.showEntityMemberDropdown = true; // show member dropdown
  //   }

  //   this.searchTerm = '';
  //   this.showDropdown = false;
  //   this.filterGuests();
  // }

  // addEntityMember(member: any) {
  //   if (!this.selectedEntityMembers.some(m => m.tmId === member.tmId)) {
  //     this.selectedEntityMembers.push({ ...member, type: 'member' });
  //   }
  //   this.searchText = '';
  //   this.showEntityMemberDropdown = false;
  //   this.filterEntityMembers();
  // }

  // removeGuest(guest: any) {
  //   this.selectedGuests = this.selectedGuests.filter(g => g.id !== guest.id);
  //   this.filterGuests();
  // }

  // removeEntityMember(member: any) {
  //   this.selectedEntityMembers = this.selectedEntityMembers.filter(m => m.tmId !== member.tmId);
  //   this.filterEntityMembers();
  // }

  onRepetitionChange(event: any) {  
    this.change = event.value;
    // console.log('evv', this.change);
    localStorage.setItem('repeat_interval', this.change);
  }

}

@Injectable()
@Component({
    selector: 'app-recurring-edit-dialog',
    templateUrl: './recurring-edit-dialog.component.html',
    styleUrls: ['./add-calendar-dialog.component.css'],
    standalone: false
})
export class RecurringEditDialogComponent {
  selectedOption: 'this' | 'forward' | 'all' = 'this';
  deleteEvent: any;
  recurrentEvent: any;
  showThisEventOption = false;
  public form: FormGroup;
  reccrule: any;
  

  constructor(
    public dialogRef: MatDialogRef<RecurringEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.form = fb.group({
      editcalenderevent: ['', Validators.required]
    });
  }

  ngOnInit() {
    // console.log('data', this.data);
    // console.log('rrr', this.data?.data.event.recurrence_rule?.frequency);

    this.reccrule = this.data?.data?.event?.recurrence_rule?.frequency;
    this.deleteEvent = localStorage.getItem('delevent');
    this.recurrentEvent = localStorage.getItem('repeat_interval');

    // console.log('reccrule (event recurrence):', this.reccrule);
    // console.log('recurrentEvent (dialog stored):', this.recurrentEvent);

    const eventRule = (this.reccrule || '').trim().toUpperCase();
    const storedRule = (this.recurrentEvent || '').trim().toUpperCase();

    // If values are equal OR recurrentEvent is null/empty → true
    this.showThisEventOption = !this.recurrentEvent || eventRule === storedRule;
    // console.log('showThisEventOption:', this.showThisEventOption);
    // console.log('dialog deleteEvent:', this.deleteEvent);
  }

  onCancel() {
    this.dialogRef.close(null);
    localStorage.removeItem('delevent')
  }

  submit() {
    // if (this.form.value.editcalenderevent === "forward") {
    //   this.form.controls['editcalenderevent'].setValue('');
    // }
    // this.emitService.next(this.form.value);
    // this.activeModal.close('');

    // if (this.form.invalid) return;

    const selectedOption = this.form.value.editcalenderevent;
    //console.log('Selected option:', selectedOption);

    this.dialogRef.close(selectedOption); // <-- Sends back value to parent

    // this.dialogRef.close(this.selectedOption);

    let okay = 'okay';
    localStorage.setItem('recurrOk', okay);
    localStorage.removeItem('delevent')
    localStorage.removeItem('repeat_interval')
  }

}


@Injectable()
@Component({
    selector: 'app-alert-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./add-calendar-dialog.component.css'],
    standalone: false
})
export class AlertDialogComponent {
  // selectedOption: 'this' | 'forward' | 'all' = 'this';
  // deleteEvent: any;
  // recurrentEvent: any;
  // public form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {

  }

  ngOnInit() {
    //console.log('dialog recurrentEvent', this.recurrentEvent)
    // console.log('dialog deleteEvent', this.deleteEvent)
  }
  onCancel(): void {
    this.dialogRef.close('cancel');
  }

  onConfirm(): void {
    this.dialogRef.close('confirm');
    localStorage.removeItem('repeat_interval')
  }

}
